import React, { useEffect, useState } from 'react';

import { useUser } from 'contexts/UserContext';

import { DOMAINCONFIG, USERS } from 'utils/rest';
import { updateDomain } from 'utils/rest/api';

const AppContext = React.createContext();

/**
 * AppProvider
 * @component
 */
export const AppProvider = props => {
  const { user, fetchUser, profile } = useUser();
  const [searchFieldValue, setSearchFieldValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [domainConfig, setDomainConfig] = useState(null);
  const [isSimplify, setIsSymplify] = useState(false);
  const [domainConfigs, setDomainConfigs] = useState([]);

  const resfreshDomainConfig = async () => {
    const result = await DOMAINCONFIG.get();
    setDomainConfig(result);
  };

  const resfreshDomainConfigs = async () => {
    const result = await DOMAINCONFIG.getAll();
    setDomainConfigs(result);
  };

  const loadApp = async () => {
    if (!user.domain) {
      // Pour eviter que ça clignote avec le polling
      setIsLoading(true);
    }
    if (
      profile
        ? profile.features?.isSimplified
        : user.roles.some(el => ['STANDARD', 'SELLER'].indexOf(el) !== -1)
    ) {
      setIsSymplify(true);
    }
    await Promise.all([resfreshDomainConfig(), resfreshDomainConfigs()]);

    setIsLoading(false);
  };

  const setDomain = async newDomain => {
    const exist = domainConfigs.find(el => el.domain === newDomain);
    if (exist) {
      setDomainConfig(exist);
      await USERS.updateUser(user.graviteeId, {
        additionalInformation: { domain: newDomain }
      });
      await fetchUser();
      updateDomain(newDomain);
    }
  };

  useEffect(() => {
    if (user.id) {
      loadApp();
      updateDomain(user.domain);
    } else {
      setIsSymplify(false);
      setDomainConfig(null);
    }
    // eslint-disable-next-line
  }, [user, profile]);

  const value = {
    domainConfig,
    setDomain,
    domainConfigs,
    searchFieldValue,
    setSearchFieldValue,
    resfreshDomainConfig,
    isSimplify,
    setIsSymplify,
    isLoading
  };
  return <AppContext.Provider {...props} value={value} />;
};

export const useApp = () => {
  const context = React.useContext(AppContext);
  if (!context) throw new Error('AppContext must be in AppProvider');
  return context;
};

export default AppProvider;
